import {
  Component,
  ViewChild,
  OnInit,
  ElementRef,
  AfterViewInit,
  Inject,
  ViewEncapsulation,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { DOCUMENT } from "@angular/common";
import { HealthSystemService } from "../core/services/v2/health-system.service";
import { AuthService } from "../auth/auth.service";

declare const WebViewer: any;
@Component({
  selector: "sasagreement",
  templateUrl: "./sasagreement.component.html",
  styleUrls: ["./sasagreement.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class SasagreementComponent implements OnInit, AfterViewInit {
  @ViewChild("viewer", { static: false }) viewer: ElementRef;
  wvInstance: any;
  signedblob: Blob;
  docviewer:any;

  ngOnInit() {
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(DOCUMENT) private document,
    public authService: AuthService,
    public healthSystemService: HealthSystemService,
  ) {}

  ngAfterViewInit(): void {
    WebViewer(
      {
        disabledElements: [
          "ribbons",
          "toggleNotesButton",
          "searchButton",
          "menuButton",
          "rubberStampToolGroupButton",
          "stampToolGroupButton",
          "fileAttachmentToolGroupButton",
          "calloutToolGroupButton",
          "undo",
          "redo",
          "eraserToolButton",
          "TextSelection",
        ],
        path: "./wv-resources/lib",
        initialDoc: "./assets/pdf/AH-HPA-SaaS-Agreement-November-2022-v-1.032.pdf",
      },
      this.viewer.nativeElement
    ).then((instance) => {
      this.wvInstance = instance;
      const { documentViewer, annotationManager } = instance.Core;
      // remove left panel and left panel button from the DOM
      instance.UI.disableElements(["leftPanel", "leftPanelButton", "selectToolButton", "panToolButton"]);
      documentViewer.addEventListener('documentLoaded', function() {
        instance.UI.setZoomLevel('150%');
      });
    });
  }
}
